/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_ReconnectingInputs */

const en_us2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting. Your trainer is still writing the answer.`)
};

const pt_br2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconectando. O personal continua escrevendo a resposta.`)
};

const es_419_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconectando. Tu entrenador sigue escribiendo la respuesta.`)
};

const pt_pt2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A restabelecer a ligação. O treinador continua a escrever a resposta.`)
};

const fr_fr2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnexion. Ton coach est toujours en train d'écrire la réponse.`)
};

const de_de2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung wird wiederhergestellt. Dein Coach schreibt noch an der Antwort.`)
};

const it_it2_coach_reconnecting = /** @type {(inputs: Coach_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riconnessione in corso. Il coach sta ancora scrivendo la risposta.`)
};

/**
* | output |
* | --- |
* | "Reconnecting. Your trainer is still writing the answer." |
*
* @param {Coach_ReconnectingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_reconnecting = /** @type {((inputs?: Coach_ReconnectingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_ReconnectingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_reconnecting(inputs)
	if (locale === "es-419") return es_419_coach_reconnecting(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_reconnecting(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_reconnecting(inputs)
	if (locale === "de-DE") return de_de2_coach_reconnecting(inputs)
	if (locale === "it-IT") return it_it2_coach_reconnecting(inputs)
	return en_us2_coach_reconnecting(inputs)
});
export { coach_reconnecting as "coach.reconnecting" }